import React, { Suspense, useState } from 'react'
import { useRoutes } from 'react-router-dom'
import PageonLoad from '@/components/pageonLoad'
import { useAppDispatch } from '@/store/hooks'
import routers from '@/router'

import { useEffect } from 'react';
import { message } from 'antd';
import eventEmitter from './eventEmitter';
import { setStudentLists, setStuId, setToken, setUid, setUserInfo } from '@/store/modules/authSlice'

import { ScrollToTop } from './hooks/ScrollToTop';
import intl, { locales } from '@/i18n/intl'; // 导入国际化配置







function App() {
  const dispatch = useAppDispatch();
  const [i18nReady, setI18nReady] = useState(false)
  const routes = useRoutes(routers)

  function setInitLogin(data: any) {
    console.log(data);
    dispatch(setToken(data.token))
    dispatch(setStuId(data.stuId))
    dispatch(setUid(data.customerId ?? data.id))
    dispatch(setStudentLists(data?.studentLists ||[]))
    dispatch(setUserInfo(data))
  }

  useEffect(() => {
    const showMessage = (msg: any) => {
      message.error(msg);
    };

    eventEmitter.on('show-message', showMessage);

    return () => {
      eventEmitter.off('show-message', showMessage);
    };
  }, []);

  // pathname
  // console.log(window.location);
  const searchParams = new URLSearchParams(window.location.search);
  const param: any = searchParams.get('locales');
  let paramSingle: any = searchParams.get('Single');
  if (paramSingle) {
    paramSingle = JSON.parse(decodeURIComponent(paramSingle));
  }

  const currentLocale = param || window.localStorage.getItem('language') || 'in-YN'
  //  浏览器默认语言
  const defaultl: string = navigator.language.toLowerCase() || "";
  console.log(defaultl, 'defaultl浏览器默认语言');


  useEffect(() => {
    let active = true

    // 国际化完成后再挂载页面，避免首次刷新读到空文案。
    setI18nReady(false)
    intl.init({
      currentLocale,
      locales,
    }).then(() => {
      if (active) setI18nReady(true)
    })

    return () => {
      active = false
    }
  }, [currentLocale]);

  useEffect(() => {
    if (param) {
      if (paramSingle && Object.values(paramSingle).length > 0) {
        console.log(Object.values(paramSingle));
        setInitLogin(paramSingle);

      }
      window.localStorage.setItem('language', param)
      window.location.replace(window.location.pathname)
    }

  }, [intl.get('global.language')])

  if (!i18nReady) {
    return <PageonLoad />
  }

  return (
    <div className="tianwaa_app">
      <ScrollToTop />
      <Suspense fallback={<PageonLoad />}>{routes}</Suspense>
    </div>
  )
}

export default App
